<template>
  <div>

    <v-row>
      <v-col cols="12">
        <div class="section-title section-title--2 text-center">
          <h2 class="heading-title">{{ mainHeading }}</h2>
          <p>
            {{ subtitle }}
          </p>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt--30">
      <!-- Start Single Team Area  -->
      <v-col
        lg="3"
        md="3"
        sm="6"
        cols="6"
        v-for="team in teamContent"
        :key="team.id"
      >
        <div class="team-static">
          <div class="thumbnail">
            <img :src="team.src" alt="Team Images" />
          </div>
          <div class="inner">
            <div class="content">
              <h4 class="title">{{ team.title }}</h4>
              <p class="designation">{{ team.designation }}</p>
            </div>

            <ul class="social-icon social-transparent liststyle d-flex">
              <li v-for="(social, i) in team.socialList" :key="i">
                <a :href="social.url" target="_blank"
                  ><i class="fab" :class="social.icon"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </v-col>
      <!-- End Single Team Area  -->
    </v-row>
  </div>
</template>

<script>
import {container} from "@/main";
import {HomeService} from "@/pages/home/home.service";

export default {
  homeService: null,
  methods: {
    detectSocialPlatform(url) {
      if (url.includes('facebook.com')) {
        return 'Facebook';
      } else if (url.includes('linkedin.com')) {
        return 'LinkedIn';
      } else if (url.includes('twitter.com')) {
        return 'Twitter';
      } else if (url.includes('instagram.com')) {
        return 'Instagram';
      }
      // Añade más plataformas si es necesario
      return null;
    }
  },
  async created() {
    this.homeService = container.get(HomeService);
    const influencers = await this.homeService.getInfluencers();
    const parser = new DOMParser();
    const doc = parser.parseFromString(influencers.content.rendered, 'text/html');

    // Extrayendo el titular principal y el subtitular
    const mainHeading = influencers.title.rendered;
    const subTitle = doc.querySelector('.wp-block-heading').textContent

    // Extrayendo información de cada persona
    const peopleInfo = Array.from(doc.querySelectorAll('.wp-block-group.alignwide.has-ast-global-color-5-background-color.has-background')).map(person => {
      const nameElement = person.querySelector('.wp-block-heading.has-large-font-size');
      const subHeadingElement = person.querySelector('.wp-block-heading:not(.has-large-font-size)');
      const imageElement = person.querySelector('img');
      const descriptionElement = person.querySelector('p');
      const socialLinksTable = person.querySelector('table');

      const name = nameElement ? nameElement.textContent : '';
      const subHeading = subHeadingElement ? subHeadingElement.textContent : '';
      const image = imageElement ? imageElement.getAttribute('data-orig-file') : '';
      const description = descriptionElement ? descriptionElement.textContent : '';

      let socialLinks = [];
      if (socialLinksTable) {
        const rows = socialLinksTable.querySelectorAll('tr');
        // Asumiendo que la segunda fila contiene los enlaces
        if (rows.length > 1) {
          const links = rows[1].querySelectorAll('a');
          socialLinks = Array.from(links).map(link => {
            const platform = this.detectSocialPlatform(link.href);
            let icon = null;
            switch (platform) {
              case 'Facebook':
                icon = 'fa-facebook-f';
                break;
              case 'LinkedIn':
                icon = 'fa-linkedin-in';
                break;
              case 'Twitter':
                icon = 'fa-twitter';
                break;
              case 'Instagram':
                icon = 'fa-instagram';
                break;
            }
            return {
                platform: link.textContent.trim(),
                icon: icon,
                url: link.href
            }
          });
        }
      }

      return { name, subHeading, image, description, socialLinks };
    });
    this.mainHeading = mainHeading;
    this.subtitle = subTitle;
    this.teamContent = [];
    let index = 0;
    for(const person of peopleInfo) {
      this.teamContent.push({
        id: index,
        src: person.image,
        title: person.name,
        designation: person.subHeading,
        socialList: person.socialLinks.map((item) => {
          return {
            icon: item.icon,
            url: item.url,
          }
        })
      });
      index++;
    }
  },
  data() {
    return {
      mainHeading: null,
      subtitle: null,
      teamContent: [],
    };
  },
};
</script>
